import http from '../http'

export const getUserList = data => {
  return http.request({
    url: '/user/queryUserInfoList',
    data,
    method: 'post'
  })
}

export const addUser = data => {
  return http.request({
    url: 'user/addUser',
    data,
    method: 'post'
  })
}

export const freezeUser = data => {
  return http.request({
    url: 'user/freezeUser',
    data,
    method: 'get'
  })
}

export const resetPassword = data => {
  return http.request({
    url: 'user/resetPassword',
    data,
    method: 'get'
  })
}

// user role
export const getUserRoleList = data => {
  return http.request({
    url: 'user/queryUserAuthMangerList',
    data,
    method: 'post'
  })
}

export const getUserRoleTree = data => {
  return http.request({
    url: 'user/queryUserRoleTree',
    data,
    method: 'get'
  })
}

export const updateUserRole = data => {
  return http.request({
    url: 'user/updateUserRole',
    data,
    method: 'post'
  })
}

// export const updateUserPlatRelation = data => {
//   return http.request({
//     url: 'user/updateUserPlatRelation',
//     data,
//     method: 'post'
//   })
// }
